"use client";

import React from "react";
import SafeHtml from "@/components/ui/SafeHtml";
import type { PostContentFields } from "@/types/acf";

export default function PostContent({ data }: { data: PostContentFields }) {
  const hide = (data as unknown as { hide?: boolean })?.hide;
  if (!data || hide) return null;

  const title = data.title ?? "";
  const text = data.text ?? "";

  if (!title && !text) return null;

  return (
    <div className="w-full">
      {title ? <h2 className="text-title-4 font-bold mb-4">{title}</h2> : null}
      {text ? (
        <div className="min-w-0 break-words">
          <SafeHtml content={text} flow />
        </div>
      ) : null}
    </div>
  );
}
